export enum EmployeeRoleType {
    Coordinator = 'Coordinator',
    Supervisor = 'Supervisor',
    Skilled = 'Skilled',
    SemiSkilled = 'Semi-Skilled',
    Unskilled = 'Unskilled'
}